import { productFamilyIdFormat } from "@redotech/redo-product-id";
import { GuidanceSourceType } from "@redotech/redo-return-core-common/exchange-agent-guidance/guidance-source-type";
import { exchangeAgentGuidanceIdFormat } from "@redotech/redo-return-id";
import * as z from "zod";

const guidanceSourceSchema = z.discriminatedUnion("type", [
  z.object({
    type: z.literal(GuidanceSourceType.PRODUCTS),
    productIds: z.array(productFamilyIdFormat.schema),
  }),
  z.object({
    type: z.literal(GuidanceSourceType.SHOPIFY_COLLECTION),
    shopifyCollectionIds: z.array(z.string()),
  }),
]);

export const updateExchangeAgentGuidance = {
  name: "updateExchangeAgentGuidance" as const,
  input: z.object({
    id: exchangeAgentGuidanceIdFormat.schema,
    /** @deprecated use source instead */
    returnProductIds: z.array(productFamilyIdFormat.schema),
    source: guidanceSourceSchema.optional(),
    recommendations: z.array(
      z.object({
        context: z.string(),
        /** @deprecated use source instead */
        productIds: z.array(productFamilyIdFormat.schema),
        source: guidanceSourceSchema.optional(),
        recommendMultipleProducts: z.boolean().optional().default(false),
      }),
    ),
  }),
  output: z.object({}),
};
